import {
  Autocomplete,
  TextField,
  FormControl,
  InputLabel,
} from "@mui/material";

const SelectComponent = ({
  options,
  value,
  onChange,
  startIcon,
  label,
  placeholder,
  noOptionsText = "Sem opções",
  ...rest
}: {
  onChange?: (i: { value: string; label: string }) => void;
  value: string;
  options: { value: string; label: string }[];
  startIcon?: React.ReactNode;
  label?: string;
  placeholder?: string;
  disabled?: boolean;
  name?: string;
  id?: string;
  noOptionsText?: string;
}) => {
  const selectedOption = options.find((opt) => opt.value === value) || null;

  return (
    <FormControl variant="standard" fullWidth {...rest}>
      {label && (
        <InputLabel
          shrink
          sx={{ color: "#fff", fontWeight: 700, fontSize: "16px" }}
        >
          {label}
        </InputLabel>
      )}

      <Autocomplete
        options={options}
        value={selectedOption}
        onChange={(_, newValue) => {
          if (newValue && onChange) onChange(newValue);
        }}
        noOptionsText={noOptionsText}
        isOptionEqualToValue={(option, value) => option.value === value.value}
        getOptionLabel={(option) => option.label}
        id={"fake-field-" + Math.random().toString(36).substring(2, 8)}
        name={"fake-field-" + Math.random().toString(36).substring(2, 8)}
        {...rest}
        renderInput={(params) => (
          <TextField
            {...params}
            placeholder={placeholder}
            sx={{
              "& .MuiOutlinedInput-root": {
                marginTop: label ? 3 : 0,
              },
            }}
            autoComplete="off"
            InputProps={{
              ...params.InputProps,
              autoComplete: "new-password",
              startAdornment: startIcon ? (
                <>
                  {startIcon}
                  {params.InputProps.startAdornment}
                </>
              ) : (
                params.InputProps.startAdornment
              ),
            }}
            inputProps={{
              ...params.inputProps,
              autoComplete: "no-autofill-phone",
              ariaAutocomplete: "none",
              "aria-autocomplete": "none",
              "aria-expanded": "false",
              "aria-controls": undefined,
            }}
          />
        )}
      />
    </FormControl>
  );
};

export default SelectComponent;
